<template>
  <div style="display: flex;flex-direction: column;">
    <el-input v-model="cargoDoc.portRequirement" :disabled="disabled" type="textarea" :rows="5" />
    <div style="display: flex;line-height: 16px;margin-top: 5px;cursor: pointer;" @click="downloadAttachment(cargoDoc.regionWarehouseMappingUuid)">
      <i class="el-icon-paperclip" style="font-size: 16px;" />
      <div style="font-size: 12px;text-decoration: underline;color: blue;">{{ $t('SystemMaintenance.PortRequirementsRelatedDocuments') }}</div>
    </div>
  </div>
</template>

<script>
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'SeCargoDocPortRequirement',
  props: {
    cargoDoc: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    downloadAttachment(regionWarehouseMappingUuid) {
      JobUtils.downloadPortRequirementAttachment(regionWarehouseMappingUuid)
    }
  }
}
</script>
